import throttle from 'lodash/throttle';

export class SoundsManagerService {
    private static __SELF__: SoundsManagerService;

    private map: Record<string, HTMLAudioElement> = {};

    public static getInstance(): SoundsManagerService {
        if (!SoundsManagerService.__SELF__) {
            SoundsManagerService.__SELF__ = new SoundsManagerService();
        }

        return SoundsManagerService.__SELF__;
    }

    /**
     * Register audio file
     * @param url
     * @param name
     */
    register(url: string, name?: string) {
        const key = name || url;
        const audio = new Audio(url);
        this.map[key] = audio;

        audio.addEventListener(
            'error',
            () => {
                this.dispose(key);
            },
            { once: true },
        );

        return this;
    }

    /**
     * Play the song by url or used name
     * @param key
     */
    play(key: string) {
        setTimeout(() => {
            if (!this.map[key] && key.startsWith('http')) {
                this.register(key);
            }

            if (this.map[key]) {
                this._player(this.map[key]);
            }
        }, 50);

        return this;
    }

    /**
     * Clean and remove an audio or entire audio map
     * @param key
     */
    dispose(key?: string) {
        if (typeof key === 'undefined') {
            Object.keys(this.map).forEach((key) => this.dispose(key));
            return this;
        }

        if (this.map[key]) {
            this.map[key].pause();
            this.map[key].remove();
            delete this.map[key];
        }

        return this;
    }

    /**
     * The player will allow max 1 play call per second
     * @private
     */
    private _player = throttle((audio: HTMLAudioElement) => {
        audio.pause();
        audio.currentTime = 0;

        const noop = () => {
            // hehehe
        };

        // noinspection JSIgnoredPromiseFromCall
        audio.play().then(noop, noop);
    }, 1000);
}
